/* eslint-disable react/destructuring-assignment */
import { TILE_LIMIT, TILE_TYPE } from '../../core/Constants';
import {
  prioritizedListNotifications,
  showingTileNotifications,
} from '../../components/LoyaltyWelcomeCard/NotificationSection/NotificationSection';
import { PrioritizeTabletList } from
'../../components/LoyaltyWelcomeCard/NotificationSection/Notifications/TabletTiles';
import {
  prioritizedListPromotions,
  showingTilePromotions,
} from '../../components/LoyaltyWelcomeCard/PromotionSection/PromotionSection';

export const createTiles = ({
  isAdmin,
  userData,
  availablePerksData,
  isLoadingPerks,
  refreshAvailablePerks,
  refreshAvailableOffers,
  availablePerksError,
  showSweepstakesTile,
  sweepstakesData,
  channel,
}) => {
  const isMobile = channel === 'mobile';
  const showingTile = {
    NOTIFICATION: showingTileNotifications({ isAdmin, userData, availablePerksData }),
    PROMOTION: showingTilePromotions({ isAdmin, userData }),
  };
  const prioritizedList = {
    NOTIFICATION: prioritizedListNotifications({
      showingTile: showingTile.NOTIFICATION,
      userData,
      availablePerksData,
      isLoadingPerks,
      refreshAvailablePerks,
      refreshAvailableOffers,
      availablePerksError,
      isAdmin,
      showSweepstakesTile,
      sweepstakesData,
    }),
    PROMOTION: prioritizedListPromotions({
      showingTile: showingTile.PROMOTION,
      userData,
      isMobile
    }),
  };
  const prioritizedTabletList = isAdmin
    ? PrioritizeTabletList(prioritizedList.NOTIFICATION, availablePerksData, isLoadingPerks)
    : PrioritizeTabletList(prioritizedList.PROMOTION, availablePerksData, isLoadingPerks);

  // Return arrays of React elements, not rendered JSX
  const filteredNotifications = prioritizedList.NOTIFICATION.filter(Boolean);
  const filteredPromotions = prioritizedList.PROMOTION.filter(Boolean);
  const filteredTablet = prioritizedTabletList.filter(Boolean);

  return {
    NOTIFICATION: filteredNotifications.slice(0, TILE_LIMIT),
    PROMOTION: filteredPromotions.slice(0, isMobile ? 2 : 4),
    TABLET: filteredTablet.slice(0, 3),
  };
};
